import React, { useState } from "react";
import styles from './apppay.module.css';
import Helmet from "react-helmet";
import { Parallax, Background } from 'react-parallax';
import { DollarSign, Edit, Link } from "react-feather";
import { Link as Linkto, useHistory, useLocation } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Checkbox, FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import Page404 from "../../auth/Page404";
import Loader from "../../../components/Loader";
import axios from 'axios';
import { useEffect } from "react";
import { SmartToaster, toast } from "react-smart-toaster";
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller } from "react-hook-form";
import { PaymentRequestButtonElement, useStripe } from "@stripe/react-stripe-js";
import NumberFormat from "react-number-format";
import Autocomplete from "react-google-autocomplete";
import { forwardRef } from "react";
import dayjs from "dayjs";
import { useRef } from "react";
import { loadStripe } from "@stripe/stripe-js";
import Step2 from "./components/Step2";
import Step1 from "./components/Step1";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY_FC);

const MoneyField = forwardRef((props, ref) => {
    return <NumberFormat prefix="" displayType="input" type="text" thousandSeparator={true} allowNegative={false} decimalScale={2} fixedDecimalScale {...props} />;
});

const FiveDigitFieldformat = forwardRef((props, ref) => {
    return <NumberFormat prefix="" displayType="input" type="text" thousandSeparator={false} decimalScale={0} {...props} />;
});

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

const AppPay = ({ history, match }) => {
    const { token } = match.params;
    const [loading, setLoading] = useState(true);
    const [isNotExist, setIsNotExist] = useState(false);
    const [propertyDet, setPropertyDet] = useState({});
    const [tenantDet, setTenantDet] = useState({});
    const [tenantDet2, setTenantDet2] = useState(null);
    const [amountType, setAmountType] = useState('');
    const [showBillingInfo, setShowBillingInfo] = useState(false);
    const [isSecondPaymentStep, setIsSecondPaymentStep] = useState(false);
    const [paymentData, setPaymentData] = useState(null);
    const [fcCustomerId, setFCCustomerId] = useState('');
    const [connectedAccounts, setConnectedAccounts] = useState([]);
    const [paymentType, setPaymentType] = useState("");
    const navigate = useHistory();
    const stripe = useStripe();
    const queryP = useQuery();
    const deviceType = queryP.get("id");
    const [clientSecret, setClientSecret] = useState(null);
    const elementContainer = useRef(null);
    const paymentElementRef = useRef(null);
    const stripeRef = useRef();
    const elementsRef = useRef();
    const [selectedAccount, setSelectedAccount] = useState(null);
    const mainDivRef = useRef(null);

    const schema = yup.object().shape({
        amount_type: yup.mixed().required('This field is Required'),
        amount: yup.string().required('This field is Required'),
        description: yup.string().required('This field is Required').max(200, 'Description cannot be more than 200 characters'),
        full_name: yup.string().required('This field is Required').max(50, 'Full name cannot be more than 50 characters'),
        email: yup.string().required('This field is reuired').email('Invalid E-mail'),
        address: yup.string(),
        address2: yup.string().max(50, 'Address 2 cannot be more than 50 characters'),
        city: yup.string(),
        state: yup.string(),
        zip: yup.string(),
        term_cond: yup.boolean().required('This field is Required').test('is-agree', 'This field is Required', (value, context) => value === true)
    });

    const { register, handleSubmit, control, errors, setValue, getValues, clearErrors } = useForm({
        resolver: yupResolver(schema), mode: 'onChange'
    });

    useEffect(() => {
        axios.get(process.env.REACT_APP_PAYMENT_API_URL + 'v1/check-tenant-payment-token/' + token).then(response => {
            let resData = response.data.data;
            setLoading(false);
            if (resData.property_id) {
                getPropertyInfo(resData.property_id);
            }

            if (resData.tenant_id) {
                getTenantInfo(resData.tenant_id);
            }

            if (resData.tenant_info_id) {
                getTenantInfoDet(resData.tenant_info_id);
            }

            if (resData.is_exist === 0) {
                setIsNotExist(true);
            }
        }).catch(error => {
            setLoading(false);
        });

        const getTenantInfo = async (id) => {
            await axios.get(process.env.REACT_APP_PAYMENT_API_URL + 'v1/tenant-payment-info/' + id).then(response => {
                let resData = response.data.data;
                setTenantDet(resData);

                setValue('address', resData?.address);
                setValue('address2', resData?.address2);
                setValue('city', resData?.city);
                setValue('zip', resData?.zip);
                setValue('state', resData?.state);

                setValue('addressnew', resData.address + ', ' + resData.city + ', ' + resData.state + ' ' + resData.zip);

                if (resData.balance2 <= 0) {
                    setTimeout(() => {
                        setValue('amount_type', 'other_amount');
                    }, 100);
                }
            });
        }

        const getTenantInfoDet = async (id) => {
            await axios.get(process.env.REACT_APP_PAYMENT_API_URL + 'v1/tenant-payment-info-det/' + id).then(response => {
                let resData = response.data.data;
                setTenantDet2(resData);

                setValue('full_name', resData?.full_name);
                setValue('email', resData?.email);
            });
        }
    }, [token, setValue]);

    const getPropertyInfo = async (id) => {
        await axios.get(process.env.REACT_APP_APPLICANT_API_URL + 'v1/application/property-det/' + id).then(response => {
            const resData = response.data.propertyDet;
            setPropertyDet(resData);
        })
    }

    const onSubmit = async (data) => {
        let amount = data.amount.replace(/,/g, '');
        amount = parseFloat(amount);

        setPaymentData({ total_amount: amount, description: data?.description, amount: amount, rentRollId: tenantDet?.last_rent_roll_id, tenantId: tenantDet?.id, tenantInfoId: tenantDet2?.id, cus_name: data?.full_name, cus_email: data.email, cus_phone: tenantDet2?.phone, cus_addr1: data?.address, cus_addr2: data?.address2, cus_city: data?.city, cus_state: data.state, cus_zip: data.zip });

        setIsSecondPaymentStep(true);
    }

    const onPlaceSelected = (place) => {
        let address = "";
        let city = "";
        let state = "";
        let postcode = "";

        for (let component of place.address_components) {
            let componentType = component.types[0];
            switch (componentType) {
                case "street_number": {
                    address = component.long_name;
                    break;
                }
                case "route": {
                    address += ' ' + component.short_name;
                    break;
                }
                case "postal_code": {
                    postcode = component.long_name;
                    break;
                }
                case "locality":
                    city = component.long_name;
                    break;
                case "sublocality_level_1":
                    city = component.long_name;
                    break;
                case "administrative_area_level_3":
                    city = component.long_name;
                    break;
                case "administrative_area_level_1": {
                    state = component.short_name;
                    break;
                }
                default:
                    break;
            }
        }

        setValue('address', address);
        setValue('city', city);
        setValue('state', state);
        setValue('zip', postcode);
    }

    useEffect(() => {
        if (tenantDet2?.id) {
            axios.get(process.env.REACT_APP_PAYMENT_API_URL + 'v1/connected-accounts/' + tenantDet2?.id).then(response => {
                setConnectedAccounts(response.data.data);
            })
        }
    }, [tenantDet2]);

    useEffect(() => {
        if (connectedAccounts.length > 0) {
            setFCCustomerId(connectedAccounts[0]?.fc_customer_id);
        }
    }, [connectedAccounts]);

    useEffect(() => {
        if (isSecondPaymentStep && mainDivRef.current) {
            mainDivRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }, [isSecondPaymentStep]);

    return (<>
        {loading && <Loader />}
        {isNotExist && <Page404 />}

        {(!isNotExist) && <>
            <Helmet title="Payment" />

            <Parallax strength={300} className="RentalParallax">
                <Background className="custom-bg">
                    <img src="/static/img/rental-app-bg.jpg" alt="fill murray" />
                </Background>
            </Parallax>

            <div className="WhiteBG">
                <div className={`${styles.RentalAppliArea}`}>
                    <div className={`${styles.RentalAppliHead}`}>
                        {(tenantDet?.theme_options?.image_url !== '') && <img src={tenantDet?.theme_options?.image_url} alt="logo" />}
                        {(tenantDet?.theme_options?.image_url === '') && <img src={'/static/img/logo.svg'} alt="logo" />}
                        <p className={`${styles.RentalAppliHeadTitle}`}>{propertyDet?.name}</p>
                        <p className={`${styles.RentalAppliHeadTitle}`}>Rent Payment</p>
                    </div>

                    <div className={`${styles.ApplicantSec}`} ref={mainDivRef}>
                        <p className={`${styles.ApplicantSecTitle}`}>{tenantDet?.balancestr}</p>
                        <p className={`${styles.ApplicantSecSubTitle}`}>{(tenantDet?.balance2 < 0) ? 'Over Paid' : 'Balance Due'}</p>


                        {!isSecondPaymentStep && <Step1 tenantDet={tenantDet} tenantDet2={tenantDet2} setPaymentData={setPaymentData.bind(this)} setIsSecondPaymentStep={setIsSecondPaymentStep.bind(this)} />}

                        {isSecondPaymentStep && paymentData && <Step2 paymentData={paymentData} connectedAccounts={connectedAccounts} setLoading={setLoading.bind(this)} tenantDet={tenantDet} tenantDet2={tenantDet2} setConnectedAccounts={setConnectedAccounts.bind(this)} isSecondPaymentStep={isSecondPaymentStep} />}
                    </div>
                </div>

                <div className={`${styles.FooterWrap}`}>
                    <div className={`${styles.footerMain}`}>

                        <div className={`${styles.footerMainLeft}`}>
                            {(tenantDet?.theme_options?.image_url !== '') && <Linkto to={'/'}><img src={tenantDet?.theme_options?.image_url} alt="logo" /></Linkto>}
                            {(tenantDet?.theme_options?.image_url === '') && <Linkto to={'/'}><img src={'/static/img/logo.svg'} alt="logo" /></Linkto>}
                        </div>

                        <div className={`${styles.footerMainRight}`}>
                            <div>
                                <h3>CONTACT US</h3>
                                <ul>
                                    <li><a href={"mailto:" + propertyDet?.email}>{propertyDet?.email}</a></li>
                                    <li><a href={"mailto:" + propertyDet?.phone}>{propertyDet?.phone}</a></li>
                                </ul>
                            </div>
                            <div>
                                <h3>FIND US</h3>
                                <ul>
                                    <li>{propertyDet?.address} <br />{propertyDet?.city}, {propertyDet?.state} {propertyDet?.zip}</li>
                                </ul>
                            </div>
                            <div>
                                <h3>LEGAL</h3>
                                <ul>
                                    <li><Linkto to={'/privacy-policy'}>Privacy Policy</Linkto></li>
                                    <li><Linkto to={'/eula'}>End User License Agreement</Linkto></li>
                                </ul>
                            </div>
                            <div>
                                <ul>
                                    <li>PropertyDek © {dayjs().format("YYYY")}.<br />All rights reserved.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>}

        <SmartToaster
            store={toast}
            lightBackground={true}
            position={"top_center"}
        />
    </>);
}

export default AppPay;
